"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InitialsAvatar = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _coreFunctionalAvatar = _interopRequireDefault(require("@vfuk/core-functional-avatar"));

var Styled = _interopRequireWildcard(require("./styles/InitialsAvatar.style"));

var _InitialsAvatar2 = _interopRequireDefault(require("./themes/InitialsAvatar.theme"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InitialsAvatar = function InitialsAvatar(_ref) {
  var initials = _ref.initials,
      to = _ref.to,
      href = _ref.href,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 2 : _ref$size,
      srText = _ref.srText,
      dataAttributes = _ref.dataAttributes,
      theme = _ref.theme;
  var localTheme = (0, _InitialsAvatar2["default"])(theme);
  return /*#__PURE__*/_react["default"].createElement(_coreFunctionalAvatar["default"], {
    backgroundColor: localTheme.backgroundColor,
    size: size,
    onClick: onClick,
    to: to,
    href: href,
    dataAttributes: dataAttributes,
    srText: srText
  }, /*#__PURE__*/_react["default"].createElement(Styled.Initials, {
    size: size
  }, initials));
};

exports.InitialsAvatar = InitialsAvatar;
InitialsAvatar.displayName = "InitialsAvatar";

var _default = (0, _styledComponents.withTheme)(InitialsAvatar);

exports["default"] = _default;
//# sourceMappingURL=InitialsAvatar.js.map